import { useEffect } from "react";
import withShow from "@common/withShow";
import Empty from "@fragments/Empty.fragment";
import Loading from "@fragments/Loading.fragment";
import CardEvent from "./fragments/CardEvent/CardEvent.fragment";
import { useTranslation } from "react-i18next";
import { useGetStatusByDate } from "@services/timeline/hooks";
import { useSidebarMetrics } from "@pages/Dashboard/hooks/useSidebarMetrics";
import { formatDateUTCToTimeLocal } from "@utils/datetime";
import { useInterval } from "@hooks/index";
import { 
  CategoryEnum,
  useFilterContext, 
} from "@pages/Dashboard/contexts/Filter.context";

import styles from "./Grid.module.scss";

const GridView: React.FC = () => {
  const { filter, category, date, setSidebarMetrics } = useFilterContext();
  const { data, refetch, isLoading, isFetching, isFetched } = useGetStatusByDate(date);
  const sidebarMetrics = useSidebarMetrics(data?.events);

  useEffect(() => {
    if (sidebarMetrics) {
      setSidebarMetrics(sidebarMetrics);
    }
  }, [sidebarMetrics, setSidebarMetrics])

  useInterval(20000, () => void refetch());

  const { t } = useTranslation();

  const text: string = category !== undefined 
    ? t(`filter.${CategoryEnum[category]}`) 
    : "na timeline";
    
  const events = data?.events
    ?.filter((event) => {
      if (!filter?.length) return true;
      return filter.includes(event.status);
    })
    ?.sort((a, b) => {
      const [hoursA, minutesA] = formatDateUTCToTimeLocal(a.plannedExecutionStart, "00:00").split(":");
      const [hoursB, minutesB] = formatDateUTCToTimeLocal(b.plannedExecutionStart, "00:00").split(":");

      const startA = new Date(1, 0, 1, Number(hoursA), Number(minutesA)).getTime();
      const startB = new Date(1, 0, 1, Number(hoursB), Number(minutesB)).getTime();

      if (startA !== startB) return startA - startB;
      
      const [endHoursA, endMinutesA] = formatDateUTCToTimeLocal(a.plannedExecutionEnd, "00:00").split(":");
      const [endHoursB, endMinutesB] = formatDateUTCToTimeLocal(b.plannedExecutionEnd, "00:00").split(":");

      const endA = new Date(1, 0, 1, Number(endHoursA), Number(endMinutesA)).getTime();
      const endB = new Date(1, 0, 1, Number(endHoursB), Number(endMinutesB)).getTime();

      if (endA !== endB) return endA - endB;

      return a.displayName.localeCompare(b.displayName, "pt-BR", { sensitivity: "base" });
    });
    
  if ((isLoading || isFetching) && !isFetched) {
    return <Loading show />
  }

  if (isFetched && events?.length) {
    return (
      <div className={styles.grid}>
        {events?.map((event, index) => ( 
          <CardEvent key={index} event={event} />
        ))}
      </div>
    );
  }

  return <Empty show>Sem eventos {text}</Empty>
}

export default withShow(GridView);